import { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import TradingPlacesViewModel from "../../../viewModels/tradingPlaces/tradingPlacesViewModel";
import PopupView from "./popupView";
import TradingPlaceHeaderView from "./tradingPlaceHeaderView";
import TradingPlaceSalesTimeView from "./tradingPlaceSalesTimeView";
import TradingPlaceContactView from "./tradingPlaceContactView";

type TradingPlaceInfoViewProps = {
  vm: TradingPlacesViewModel;
  mobileView: boolean;
};

const TradingPlaceInfoView: React.FC<TradingPlaceInfoViewProps> = observer(({ vm, mobileView }) => {
  return (
    <PopupView vm={vm}>
      <TradingPlaceHeaderView vm={vm} />
      {vm.visibleTradingPlaces.salesPoint && mobileView ? (
        <>
          <div className={`${vm.mobileHideSalesPoint ? "over-map-hidden" : ""}`}>
            <TradingPlaceSalesTimeView vm={vm} />
            <TradingPlaceContactView vm={vm} />
          </div>
          <button
            className={`btn-map ${vm.mobileHideSalesPoint ? "btn-map-down" : "btn-map-up"}`}
            onClick={() => vm.toogleMobileSalesPoint()}>
            {" "}
          </button>
        </>
      ) : (
        <>
          <TradingPlaceSalesTimeView vm={vm} />
          <TradingPlaceContactView vm={vm} />
        </>
      )}
    </PopupView>
  );
});

export default TradingPlaceInfoView;
